import HeadlessCombobox from "@components/Combobox";
import FormField from "@components/FormField";
import { useField } from "formik";
import { forwardRef } from "react";

function FormikCombobox(
  {
    label,
    options,
    error,
    onOptionChange = null,
    disabled = false,
    pageSize = 0,
    ...props
  },
  ref
) {
  const [field, , helpers] = useField(props.name);

  const selectedOption = options.find(
    (opt) => String(opt.value) === String(field.value)
  ) || {
    value: field.value,
  };

  const handleSelect = (opt) => {
    if (onOptionChange) {
      onOptionChange(opt, {
        setFieldValue: (name, val) => helpers.setValue(val),
      });
    }
  };

  return (
    <FormField label={label} id={props.name} errorMsg={error}>
      <HeadlessCombobox
        field={field}
        helpers={helpers}
        name={props.name}
        value={selectedOption}
        onChange={(opt) => helpers.setValue(opt.value)}
        onOptionChange={(opt) => handleSelect(opt)}
        options={options}
        ref={ref}
        errorMsg={error}
        pageSize={pageSize}
        data-testid={`${props.name}-combobox`}
        disabled={disabled}
      />
    </FormField>
  );
}

export default forwardRef(FormikCombobox);
